import {SignalStatus} from '@domain/kiln-monitoring'
import {Grid} from '@mui/material'

import {KilnMetricStatus} from '../shared'

type Props = {
  isLoading: boolean
  sensorAreas?: Record<string, string>
  gridItemSettings: {
    xs: number
    md: number
    lg: number
  }
}

export const KilnSensorAreaStatusGrid = ({isLoading, sensorAreas, gridItemSettings}: Props) => {
  if (!sensorAreas) {
    return null
  }

  return (
    <Grid
      direction="row"
      rowSpacing={1}
      columnSpacing={1}
      columns={{
        xs: 10,
        sm: 16,
        lg: 8
      }}
      container
      data-test-id="kiln-sensors-statuses"
    >
      {Object.keys(sensorAreas).map((areaKey) => (
        <Grid
          item
          key={areaKey}
          {...gridItemSettings}
          data-test-id={`kiln-sensor-status-${areaKey}`}
        >
          <KilnMetricStatus
            title={areaKey}
            status={sensorAreas[areaKey] as SignalStatus}
            loading={isLoading}
          />
        </Grid>
      ))}
    </Grid>
  )
}
